import React from "react";

function Spinner({ loading }) {
    return (
        <div className="spinner_cont">
            {loading && (
                <div id="spinner" className="spinner-border" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            )}
        </div>
    );
}

export default Spinner;
